import React from 'react';

import { isMediaId } from '~/src/common/media';
import { Autoplay, BasicPlayer } from '~/src/components/MediaPlayer';

import { LogConsumption } from './LogConsumption';
import { NextButton } from './NextButton';
import { usePlayback } from './PlaybackProvider';
import { SaveAndRestorePosition } from './SaveAndRestorePosition';
import { YouboraAnalytics } from './YouboraAnalytics';

export const Player: React.FC = () => {
  const { episode } = usePlayback();
  const mediaId = episode.mediaId();
  const episodeId = episode.id();
  if (!isMediaId(mediaId)) {
    return null;
  }

  return (
    <BasicPlayer mediaId={mediaId}>
      {episodeId && <SaveAndRestorePosition />}
      {episodeId && <LogConsumption episodeId={episodeId} />}
      <NextButton />
      <Autoplay />
      <YouboraAnalytics episode={episode} />
    </BasicPlayer>
  );
};
